import styled from 'styled-components';
export const StyledInputSwitch = styled.span `
  &&& {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 1.25rem;
    width: 3rem;
    border-radius: 25px;
    background-color: ${({ active, theme }) => active
    ? `rgba(${theme.colors.transparentBlack}, 0.26);`
    : `rgba(${theme.colors.transparentBlack}, 0.2)`};

    &:before,
    &:after {
      position: absolute;
      content: '';
      transition: 0.4s;
      border: 1px solid transparent;
      border-radius: 50%;
    }

    &:before {
      width: 2.375rem;
      height: 2.375rem;
      left: -0.5rem;
      top: -0.625rem;
      ${({ active, theme }) => active ? `background-color: rgba(${theme.colors.transparentBlack}, 0.26)!important;` : ''};
    }

    &:after {
      width: 1.375rem;
      height: 1.375rem;
      left: 0;
      top: -0.125rem;
      background-color: ${({ theme }) => theme.colors.white};
      box-shadow: 0 1px 2px rgba(${({ theme }) => theme.colors.transparentBlack}, 0.36);
    }
  }
`;
export const StyledInput = styled.input `
  opacity: 0;
  width: 0;
  height: 0;

  &:checked {
    & + ${StyledInputSwitch} {
      background-color: ${({ theme }) => theme.colors.primaryLight};

      &:after,
      &:before {
        transform: translateX(1.5rem);
      }
    }

    &:hover
      + ${StyledInputSwitch},
      &:focus
      + ${StyledInputSwitch},
      &:active
      + ${StyledInputSwitch} {
      background-color: ${({ theme }) => theme.colors.primaryLight};
    }

    &:disabled + ${StyledInputSwitch}, &:disabled:hover + ${StyledInputSwitch} {
      background-color: rgba(${({ theme }) => theme.colors.transparentPrimaryLight}, 0.4);
    }
  }

  &:hover + ${StyledInputSwitch} {
    background-color: rgba(${({ theme }) => theme.colors.transparentBlack}, 0.26);

    &:before {
      background-color: rgba(${({ theme }) => theme.colors.transparentBlack}, 0.08);
    }
  }

  &:focus + ${StyledInputSwitch} {
    ${({ focused, theme }) => focused ? `background-color: rgba(${theme.colors.transparentBlack}, 0.2);` : ''}

    &:before {
      ${({ focused, theme }) => (focused ? `border: 1px solid ${theme.colors.primaryLight};` : '')}
    }
  }

  &:disabled
    + ${StyledInputSwitch},
    &:disabled:hover
    + ${StyledInputSwitch},
    &:disabled:active
    + ${StyledInputSwitch},
    &:disabled:focus
    + ${StyledInputSwitch} {
    background-color: rgba(${({ theme }) => theme.colors.transparentBlack}, 0.08);
    cursor: default;

    &:after {
      background-color: ${({ theme }) => theme.colors.grey05};
    }

    &:before {
      display: none;
    }
  }
`;
